const defaultQuality = 75;

const cloudflare = (c) => {
    let params = [
        c.height ? `h=${ c.height }` : null,
        c.width ? `w=${ c.width }` : null,
        c.dpr ? `dpr=${ c.dpr }` : null,
        c.original ? null : `f=auto`,
        `q=${ c.quality || defaultQuality }`,
        `fit=${ c.crop ? `crop` : `contain` }`,
        c.transparent ? null : `background=white`,
    ].filter(e => e != null).join(',');

    let parts = c.src.replace(/^\//, '').split('/');
    let name = encodeURIComponent(parts.pop());

    return `https://${ c.host }/cdn-cgi/image/${ params }/${ [...parts, name].join('/') }`;
};

export default cloudflare;
